import * as React from 'react';
import { useRouteData } from 'react-static';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { BrandsCollectionsResults } from '../../components/brands-collections-results/BrandsCollectionsResults';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../default/DefaultLayout';
import { LocaleProps } from '../default/DefaultLayout.props';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { locale, translatedPaths } = useRouteData<LocaleProps>();
  const { t } = useTranslations(translations, locale);
  const seo = {
    description: '',
  };
  const alt = t('imageAlt', 'WB Brands');
  const imageWithPresets: ImageWithPresets = {
    image: {
      alt,
      src: '/assets/images/banner/default-wb.jpg',
    },
    tabletImage: {
      alt,
      src: '/assets/images/banner/default-wb-tablet.jpg',
    },
    mobileImage: {
      alt,
      src: '/assets/images/banner/default-wb-mobile.jpg',
    },
  };

  useDebug('app:layout:BrandsLayout', { props: { locale } });

  return (
    <DefaultLayout locale={locale} seo={seo} translatedPaths={translatedPaths}>
      <HeadTitle title={t('pageTitle', 'Brands')} />
      <FeaturedBanner
        headingTag='h1'
        imageWithPresets={imageWithPresets}
        titleProps={{
          addlTitleData: {
            marketingMessage: t(
              'bannerSubTitle',
              'From witchcraft and wizardry to superhumans and animated animals, ' +
                'explore our iconic brands across film, TV and games.',
            ),
          },
          title: t('bannerTitle', 'Brands'),
        }}
      />
      <BrandsCollectionsResults contentType='Brands' query='f[0]=type:brands&qt=%20' />
    </DefaultLayout>
  );
};
